window.$ = window.jQuery = require('jquery');
import preloader from '../preloader/preloader';
/**
 * @class
 */
export default class Orders {
    /**
     * Initialize Header
     * @function
     */
    constructor(el) {
        this.el = el;
        this.bindEvents();
    }

    bindEvents() {
        this.el.find('.new-order-btn').on('click', (event) => {
            preloader.open('Processing new order', 'Please wait while we fetch new orders...');
            $.ajax({
               type:'GET',
               url: $("#logo").attr('href') + '/process-new-orders',
               success:function(data){
                   preloader.close();
                   location.reload(true);
               }
            });
//            setTimeout(function () {
//                $('.nav-tabs a[href="#tab-two"]').tab('show');
//            }, 800);
//            setTimeout(function () {
//                preloader.close();
//            }, 1000);
        })
    }

}
